export default __webpack_public_path__ + "61cda3d17f444a395675255aa4efb7be.png";